import { IApplicationState, TCardId } from '../../../../../../types/types';

export const getCurrentNotFilledCardId = (
    state: IApplicationState,
): TCardId => {
    return state && state.cardPanel && state.cardPanel.notFilledCards && state.cardPanel.notFilledCards.currentNotFilledCardId;
};
